module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAKCAYAAABmBXS+AAAAcklEQVQYlX3QMQrCUBBF0SHYWFnbuIXgUlyCrVtI6zZssoJ0WYq1tUUCglbh2Dgg4v8XXjWXmeEFBuwRpQRmLOixq0nJE2dsalJyxwmrmpRccWiizisipihsuOGIJs9980CH9e/jPhVcsC1VMKL9N8y8AVJ8GKztY8QaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sanjiao.png
// module id = 8psQ
// module chunks = 15